import React from 'react'
import Main from '../components/Main'

const Home = () => {
  return (
    <div>
      <Main/>
    </div>
  )
}

export default Home
